<span class="menu-toggle clickable" [class.selected]="selected" [class.invalid]="invalid && !selected" (click)="onToggleMenu()">
  <i class="fa fa-ellipsis-h fa-lg" aria-hidden="true"></i>
</span>
<br>
  @if (showDropDown) {
    <div class="message-actions no-text-selection">
      <i class="fa fa-times pull-right clickable fa-lg" aria-hidden="true" (click)="onCloseMenu()"></i>
      <br>
        @for (menuItem of menuItems; track menuItem) {
          <div (click)="menuItem.onClickHandler($event)">{{menuItem.labelText}}</div>
        }
      </div>
    }
